import React, {useEffect, useState} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import InputSlider from "../../../../components/input/input-slider.jsx";
import {useQuery} from "@tanstack/react-query";
import corporationService from "../../../../services/web/corporation-service.js";
import LatLngInput from "../../../../components/input/lat-lng-input.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { encounterListTeam } = useReportFiltersFetch({fetchEncounterListTeam: true});
    const [markerPositionString, setMarkerPositionString] = useState('');
    const [markerPosition, setMarkerPosition] = useState(null);

    const {data: corporation} = useQuery({
        queryFn: () => corporationService.entity(),
        queryKey: ["corporation"]
    });

    const latitude = parseFloat(corporation?.latitude) || 0;
    const longitude = parseFloat(corporation?.longitude) || 0;

    const position = {
        lat: latitude,
        lng: longitude
    }

    useEffect(() => {
        setMarkerPositionString(filters.latLng ?? '');
    }, [filters.latLng]);

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <SelectComponent
                            label='Equipe'
                            isMulti={true}
                            wrapValues={true}
                            options={encounterListTeam}
                            value={filters.garrison_team}
                            onChange={(value) => setFilters(prev => ({...prev, garrison_team: value}))}
                            instanceId="garrison_team"
                            classNameWrapper={"w-full"}
                        />

                        <LatLngInput
                            label="Ponto no mapa"
                            position={position}
                            corporation={corporation}
                            value={filters.latLng}
                            onChange={(value) => setFilters(prev => ({ ...prev, latLng: value }))}
                            setMarkerPositionString={setMarkerPositionString}
                            markerPositionString={markerPositionString}
                            markerPosition={markerPosition}
                            setMarkerPosition={setMarkerPosition}
                            className={"w-full cursor-pointer"}
                        />

                        <InputSlider
                            label="Raio (M)"
                            value={filters.range}
                            setValue={(value) => setFilters(prev => ({...prev, range: value}))}
                            min={10}
                            max={1000}
                            step={1}
                        />

                        <AccessForm filters={filters} setFilters={setFilters}/>

                </form>
            </div>
        </>
    );
};

export default Filters;